export class ManualTransaction {
  constructor(
    public iPlaceId: string,
    public localTankId: number,
    public tankId: string,
    public tankName: string,
    public productId: string,
    public sales: number,
    public hdSiraExported: boolean,
    public creationDate: number,
    public creationUser: string
  ) {}
}
